// this file provides a map to image paths
// these images are put into the build directory by webpack

import blueDownArrowIcon from "./icon_arrow_down_blue.png";
import fadedBlackBackground from "./2_2_faded_black.png";
import sortTriangleDown from "./common_triangle_down.png";
import sortTriangleUp from "./common_triangle_up.png";
import forPlacementOnlyImage from "./for-placement-only.png";
import hiddenIconActive from "./icon_hide_toggle_active.png";
import hiddenIconDark from "./icon_hidden_dark.png";
import hiddenIconInactive from "./icon_hide_toggle_inactive.png";
import promotionImageNotAvailable from "./image_not_available_promotion.png";
import notificationImageNotAvailable from "./image_not_available_notification.png";
import filePreviewNotAvailable from "./file_preview_not_available.png";
import scheduledPNIcon from "./icon_PNscheduled.png";
import locationActiveIcon from "./locations_active.png";
import locationInactiveIcon from "./locations_inactive.png";
import phoneHomeIcon from "./tab_home_active.png";
import phoneShopIcon from "./tab_shop_active.png";
import phoneOffersIcon from "./tab_offers_active.png";
import phoneStoresIcon from "./tab_stores_active.png";
import phoneCardIcon from "./tab_card_active.png";
import photoIcon from "./common_upload_image.png";
import platformAndroidActive from "./icon_android_active.png";
import platformAndroidInactive from "./icon_android_inactive.png";
import platformIosActive from "./icon_apple_active.png";
import platformIosInactive from "./icon_apple_inactive.png";
import plusCircleIcon from "./icon_add_widget.png";
import removeXIcon from "./icon_remove.png";
import rowsActiveIcon from "./icon_rows_active.png";
import rowsInactiveIcon from "./icon_rows_inactive.png";
import scheduledActiveIcon from "./notifications_active.png";
import scheduledInactiveIcon from "./notifications_inactive.png";
import searchIcon from "./icon_search.png";
import visibleIconActive from "./icon_show_toggle_active.png";
import visibleIconDark from "./icon_visible_dark.png";
import visibleIconInactive from "./icon_show_toggle_inactive.png";
import smallMap from "./small-map.png";
import tileActiveIcon from "./icon_tiles_active.png";
import tileInactiveIcon from "./icon_tiles_inactive.png";
import toolTipIcon from "./icon_help.png";
import xCircleIcon from "./icon_close_widget.png";
import checkmark from "Static/img/icons/checkmark.png";
import editIcon from "./icon_edit.png";
import deleteIcon from "./icon_delete.png";
import checkIcon from "./icon_check.png";
import questionIcon from "./icon_question.png";
import copyIcon from "./icon_copy.png";
import synchronyFinancialLogo from "./Logo_of_Synchrony_Financial.jpg";
import appDefaultLogo from "./app-default-logo.png";
import plusIcon from "./icon_add.png";
import minusIcon from "./icon_minus.png";
import refreshIcon from "./icon_outline_refresh.png";
import syfTrashBin from "./syf-trash-bin.png";

const sortTriangle = {
  up: sortTriangleUp,
  down: sortTriangleDown,
};

const imageNotAvailable = {
  promotion: promotionImageNotAvailable,
  notification: notificationImageNotAvailable,
};
const notificationTypeIcons = {
  scheduled: {
    active: scheduledActiveIcon,
    inactive: scheduledInactiveIcon,
    logo: scheduledPNIcon,
  },
};

const phoneNavigationIcons = {
  home: phoneHomeIcon,
  shop: phoneShopIcon,
  offers: phoneOffersIcon,
  stores: phoneStoresIcon,
  card: phoneCardIcon,
};

const platformIcons = {
  android: {
    active: platformAndroidActive,
    inactive: platformAndroidInactive,
  },
  ios: {
    active: platformIosActive,
    inactive: platformIosInactive,
  },
};

const visibilityIcons = {
  visible: {
    active: visibleIconActive,
    inactive: visibleIconInactive,
  },
  hidden: {
    active: hiddenIconActive,
    inactive: hiddenIconInactive,
  },
};

const tableStyleIcons = {
  rows: {
    active: rowsActiveIcon,
    inactive: rowsInactiveIcon,
  },
  tiles: {
    active: tileActiveIcon,
    inactive: tileInactiveIcon,
  },
};

export {
  blueDownArrowIcon,
  fadedBlackBackground,
  sortTriangle,
  checkmark,
  forPlacementOnlyImage,
  imageNotAvailable,
  filePreviewNotAvailable,
  notificationTypeIcons,
  phoneNavigationIcons,
  photoIcon,
  platformIcons,
  plusCircleIcon,
  removeXIcon,
  searchIcon,
  visibilityIcons,
  visibleIconDark,
  hiddenIconDark,
  smallMap,
  toolTipIcon,
  tableStyleIcons,
  xCircleIcon,
  copyIcon,
  editIcon,
  deleteIcon,
  checkIcon,
  questionIcon,
  synchronyFinancialLogo,
  appDefaultLogo,
  plusIcon,
  refreshIcon,
  minusIcon,
  syfTrashBin,
};
